<template>
  <b-container fluid>
    <b-row align-h="center">
      <b-col cols="8">
        <h2 class="header">Maintain AssignmentTerms Option IDs</h2>
        <div role="tablist">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block href="#" v-b-toggle.mapExclusionCriteria variant="light">
                Map Exclusion Criteria
              </b-button>
            </b-card-header>
            <b-collapse id="mapExclusionCriteria" visible accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <MapExclusionCriteria />
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-alert variant="info" show>
            We are using a kind of reverse logic in <strong>next three panels</strong>. To uncheck an option you have to add the respective UUID. To check the option you have to remove the UUID again.
            <br>
            To do so add the UUID-IDS below and it will remove or add them.
          </b-alert>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block href="#" v-b-toggle.updateAnswersOfProduct variant="light">
                Update Answers of Product
              </b-button>
            </b-card-header>
            <b-collapse id="updateAnswersOfProduct" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <UpdateAnswersOfProduct />
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block href="#" v-b-toggle.updateAnswersOfVendor variant="light">
                Update Answers of Vendor
              </b-button>
            </b-card-header>
            <b-collapse id="updateAnswersOfVendor" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <UpdateAnswersOfVendor />
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block href="#" v-b-toggle.updateAnswersOfAssignmentTerms variant="light">
                Update Answers of Assignment Terms
              </b-button>
            </b-card-header>
            <b-collapse id="updateAnswersOfAssignmentTerms" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <UpdateAnswersOfAssignmentTerms />
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import MapExclusionCriteria from './MapExclusionCriteria.vue'
import UpdateAnswersOfProduct from './UpdateAnswersOfProduct.vue'
import UpdateAnswersOfVendor from './UpdateAnswersOfVendor'
import UpdateAnswersOfAssignmentTerms from './UpdateAnswersOfAssignmentTerms.vue'

export default {
  name: 'OptionIdsMaintenance',
  components: {
    MapExclusionCriteria,
    UpdateAnswersOfProduct,
    UpdateAnswersOfVendor,
    UpdateAnswersOfAssignmentTerms
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  margin-top: 25px;
  margin-bottom: 25px;
}
</style>
